module.exports = __webpack_public_path__ + "img/logo-igarape-branco.85b21899.png";